angular.module('elfium').directive('reportTable', ['elfiumUrlService', function (elfiumUrlService) {
    return {
        restrict: 'E',
        scope: {
        	businessCaseId: '=',
        	updateCallback: '=',
        	reportsByTypes: '=?reports',
        	isDirty: '=?'
        },
        controller: 'reportTableController',
        templateUrl: elfiumUrlService.getTemplateUrl('report', 'reportTable')
    };
}]);


// WEBPACK FOOTER //
// ./src/app/components/report/reportTable.ts